module.exports = __webpack_public_path__ + "static/media/pilot_icon.5a98e264.svg";